import { createHashRouter } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import TheaterLoginPage from "../pages/TheaterLoginPage/TheaterLoginPage";
import BannersPage from "../pages/BannersPage/BannersPage";
import MenuPage from "../pages/MenuPage/MenuPage";
import MoviesPage from "../pages/MoviesPage/MoviesPage";
import Showtime from "../pages/ShowtimePage/ShowtimePage";
import { RestrictedRoute } from "../utils/authMiddleware";
import NavigationLayout from "../layouts/NavigationLayout";
import SessionLayout from "../layouts/SessionLayout";

export const router = createHashRouter([
  {
    path: "/",
    element: <MainLayout />,
    children: [
      {
        index: true,
        element: (
          <RestrictedRoute>
            <TheaterLoginPage />
          </RestrictedRoute>
        ),
      },
      {
        path: "banners",
        element: (
          <SessionLayout>
            <BannersPage />
          </SessionLayout>
        ),
      },
      {
        path: "menu",
        element: <MenuPage />,
      },
      {
        path: "peliculas",
        element: (
          <SessionLayout>
            <NavigationLayout>
              <MoviesPage />
            </NavigationLayout>
          </SessionLayout>
        ),
      },
      {
        path: ":theater/pelicula/:slug/funcion/:showtime",
        element: (
          <SessionLayout>
            <NavigationLayout>
              <Showtime />
            </NavigationLayout>
          </SessionLayout>
        ),
      },
      {
        path: "*",
        element: <h2>404</h2>,
      },
    ],
  },
]);
